import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEllipsisV = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M12 7a2 2 0 1 0-2-2 2 2 0 0 0 2 2m0 10a2 2 0 1 0 2 2 2 2 0 0 0-2-2m0-7a2 2 0 1 0 2 2 2 2 0 0 0-2-2" />
  </svg>
);
export default SvgEllipsisV;
